import React from 'react';
import UnitIcon from './unit_icon';

/**
 * BatteryMapCell Component
 * Renders a single cell in the battery map table with proper spanning and alignment
 * 
 * @param {Object} cell - Cell data containing unit information
 * @param {number} rowIndex - Row index in the table
 * @param {number} columnIndex - Column index in the table
 * @param {number} cellSize - Size of the cell in pixels
 * @param {number} locationNum - Location number
 * @param {number} stringNum - String number
 * @param {number} scale - Scale factor for the icon
 */
const BatteryMapCell = ({
	cell,
	rowIndex,
	columnIndex,
	cellSize,
	locationNum,
	stringNum,
	scale = 1.0
}) => {
	// Skip cells that are part of a span
	if (cell && cell.isSpanned) {
		return null;
	}

	const rowspan = cell?.rowspan || 1;
	const colspan = cell?.colspan || 1;
	const alignment = cell?.alignment || { vertical: 'center', horizontal: 'center' };

	return (
		<td
			key={`${rowIndex},${columnIndex}`}
			style={{
				width: cellSize,
				height: cellSize,
				verticalAlign: alignment.vertical,
				textAlign: alignment.horizontal,
			}}
			rowSpan={rowspan}
			colSpan={colspan}
		>
			{cell && !cell.isSpanned && (
				<UnitIcon
					locationNum={locationNum}
					stringNum={stringNum}
					unitNum={cell.unit_number}
					unitShape={cell.unit_shape}
					unitState={cell.unit_status}
					unitDates={cell.unit_dates}
					unitAlarms={[]}
					scale={scale}
				/>
			)}
		</td>
	);
};

export default BatteryMapCell;
